import React from 'react';
import { LoadingBalls } from '@moda/om';
import { DesignerChip, DesignerChipProps } from '../DesignerChip';
import { useSingleDesignerChip } from './useSingleDesignerChip';

type OmittedDesignerChipProps = 'id' | 'name' | 'onFollow' | 'onUnfollow' | 'isFollowed';

type Props = Omit<DesignerChipProps, OmittedDesignerChipProps>;

export const SingleDesignerChip: React.FC<Props> = props => {
  const { handleFollow, isFollowed, designer, handleUnfollow, loading } = useSingleDesignerChip();

  if (loading) return <LoadingBalls />;

  if (!designer) return null;

  return (
    <DesignerChip
      id={designer.id}
      name={designer.name}
      onFollow={handleFollow}
      onUnfollow={handleUnfollow}
      isFollowed={isFollowed}
      {...props}
    />
  );
};
